let unlocked = false;
let unlocking = null;

function log(...args) {
	// eslint-disable-next-line no-console
	console.log('[audio]', ...args);
}

async function tryUnlockOnce() {
	// 1) AudioContext 解锁
	try {
		const AudioCtx = window.AudioContext || window.webkitAudioContext;
		if (AudioCtx) {
			const ctx = new AudioCtx();
			if (ctx.state === 'suspended') {
				await ctx.resume();
			}
			// 立即关闭，避免占用资源
			await ctx.close();
		}
	} catch (e) {
		// ignore
	}

	// 2) HTMLAudioElement 解锁
	try {
		const a = new Audio();
		// 空 src 不可靠，使用极短静音 dataURI
		a.src =
			'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAESsAACJWAAACABAAZGF0YQAAAAA=';
		a.muted = true;
		a.playsInline = true;
		const p = a.play();
		if (p && typeof p.then === 'function') {
			await p;
		}
		a.pause();
	} catch (e) {
		// ignore
	}
}

export function isAudioUnlocked() {
	return unlocked;
}

export async function ensureAudioUnlocked() {
	if (unlocked) return true;
	if (unlocking) return unlocking;

	unlocking = (async () => {
		try {
			await tryUnlockOnce();
			unlocked = true;
			log('unlocked');
			return true;
		} catch (e) {
			return false;
		} finally {
			unlocking = null;
		}
	})();

	return unlocking;
}

export function installAudioUnlockListeners() {
	if (typeof window === 'undefined') return;
	const handler = () => {
		ensureAudioUnlocked();
		// 只需要一次交互就够了
		window.removeEventListener('click', handler, true);
		window.removeEventListener('touchstart', handler, true);
		window.removeEventListener('keydown', handler, true);
	};
	window.addEventListener('click', handler, true);
	window.addEventListener('touchstart', handler, true);
	window.addEventListener('keydown', handler, true);
}

